// extracted by mini-css-extract-plugin
export var clientLogo = "logo-strip-module--clientLogo--64745";
export var clientLogoForMobile = "logo-strip-module--clientLogoForMobile--e9e5b";
export var clientLogosContainer = "logo-strip-module--clientLogosContainer--2d093";
export var flipHorizontal = "logo-strip-module--flipHorizontal--27303";
export var whiteShadow = "logo-strip-module--whiteShadow--19dbd";